const translations = {
    viewRecentActivity: 'View recent activity →'
};

export default translations;
